import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import moment from "moment";
import 'moment/locale/pt-br';

import { 
  BarChart, 
  Bar, 
  XAxis, 
  YAxis,
  Legend,
  Tooltip as RechartsTooltip,
  CartesianGrid,
  ResponsiveContainer
} from 'recharts';

import Header from '../../components/Header';
import ModalShift from '../../components/modals/ModalShift';
import InputDate from '../../components/inputs/InputDate';
import { Loading, TableLoading } from '../../components/ResponsiveLoading';

import dash from '../../assets/images/dash.svg';
import pin2 from '../../assets/images/pin2.svg';
import br from '../../assets/images/brazil.svg';
import sp from '../../assets/images/sp.svg';
import rj from '../../assets/images/rj.svg';

import closeCircle from '../../assets/images/closeCircle.svg';
import calendar5 from '../../assets/images/calendar5.svg';
import calendar4 from '../../assets/images/calendar4.svg';
import calendar6 from '../../assets/images/calendar6.svg';
import calendar7 from '../../assets/images/calendar7.svg';
import calendar8 from '../../assets/images/calendar8.svg';
import check3 from '../../assets/images/check3.svg';
import waiting from '../../assets/images/waiting.svg';
import plusCircle from '../../assets/images/plusCircle.svg';
import api from '../../services/api';
import getUserInfo from "../../services/getUserInfo";

import './styles.css';
import ModalPeriodo from '../../components/modals/ModalPeriodo';
import ModalRegion from '../../components/modals/ModalRegion';
import { createUrlParamsFromObject } from '../../services/helpers';

const baseRankings = {
  corretores: [], 
  gerentes: [], 
  superintendentes: []
};

const labels = {
  concretizados: 'Concretizados',
  nao_concretizados: 'Não concretizados'
};

export const Agendamentos = () => {
  const today = new Date();

  const [gerentes, setGerentes] = useState([]);
  const [superintendentes, setSuperintendentes] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [regionais, setRegionais] = useState([]);
  const [totalShifts, setTotalShifts] = useState(0);
  const [totalShiftsNumber, setTotalShiftsNumber] = useState(0);
  const [periodo, setPeriodo] = useState('diario');
  const [showModalProximosAgendamentosRegiao, setShowModalProximosAgendamentosRegiao] = useState(false);
  const [proximosAgendamentos, setProximosAgendamentos] = useState(null);
  const [historicoAgendamentos, setHistoricoAgendamentos] = useState(null);
  const [evolucaoAgendamentosConcretizados, setEvoluacaoAgendamentosConcretizados] = useState(null);
  const [evolucaoAgendamentosNaoConcretizados, setEvoluacaoAgendamentosNaoConcretizados] = useState(null);
  const [rankingAgendamentos, setRankingAgendamentos] = useState(baseRankings);
  const [rankingAgendamentosNaoConcretizados, setRankingAgendamentosNaoConcretizados] = useState(baseRankings);

  const [loadingShifts, setLoadingShifts] = useState(true);
  const [loadingProximosAgendamentos, setLoadingProximosAgendamentos] = useState(true);
  const [loadingHistoricoAgendamentos, setLoadingHistoricoAgendamentos] = useState(true);
  const [loadingEvolucaoAgendamentos, setLoadingEvolucaoAgendamentos] = useState(true);
  const [loadingRankingAgendamentosConcretizados, setLoadingRankingAgendamentosConcretizados] = useState(true);
  const [loadingRankingAgendamentosNaoConcretizados, setLoadingRankingAgendamentosNaoConcretizados] = useState(true);

  const [regiaoProximosAgendamentos, setRegiaoProximosAgendamentos] = useState(null);
  const [showModalPlantoesProximosAgendamentos, setShowModalPlantoesProximosAgendamentos] = useState(false);
  const [plantoesProximosAgendamentos, setPlantoesProximosAgendamentos] = useState([]);

  const [plantoesHistorico, setPlantoesHistorico] = useState([]);
  const [regiaoHistorico, setRegiaoHistorico] = useState(null);
  const [showModalHistoricoRegiao, setShowModalHistoricoRegiao] = useState(false);
  const [showModalHistoricoPlantoes, setShowModalHistoricoPlantoes] = useState(false);
  const [dataInicialHistorico, setDataInicialHistorico] = useState(today);
  const [dataFinalHistorico, setDataFinalHistorico] = useState(today);

  const [showModalEvolucaoRegiao, setShowModalEvolucaoRegiao] = useState(false);
  const [showModalEvolucaoPlantoes, setShowModalEvolucaoPlantoes] = useState(false);
  const [showModalEvolucaoPeriodo, setShowModalEvolucaoPeriodo] = useState(false);
  const [regiaoEvolucao, setRegiaoEvolucao] = useState(null);
  const [plantoesEvolucao, setPlantoesEvolucao] = useState([]);

  const [showModalRankingConcretizadosRegiao, setShowModalRankingConcretizadosRegiao] = useState(false);
  const [showModalRankingNaoConcretizadosRegiao, setShowModalRankingNaoConcretizadosRegiao] = useState(false);
  const [regiaoRankingConcretizados, setRegiaoRankingConcretizados] = useState({});
  const [regiaoRankingNaoConcretizados, setRegiaoRankingNaoConcretizados] = useState({});
  const [dataInicialRankingConcretizados, setDataInicialRankingConcretizados] = useState(today);
  const [dataFinalRankingConcretizados, setDataFinalRankingConcretizados] = useState(today);
  const [dataInicialRankingNaoConcretizados, setDataInicialRankingNaoConcretizados] = useState(today);
  const [dataFinalRankingNaoConcretizados, setDataFinalRankingNaoConcretizados] = useState(today);

  const [userInfo, setUserInfo] = useState({});

  const [evolucaoAgendamentos, setEvolucaoAgendamentos] = useState([]);

  const [icon] = useState({
    'br': br,
    'sp': sp,
    'rj': rj
  });

  useEffect(() => {
    getUserInfo().then(user => {
      setUserInfo(user);
    });

    getShifts();
  }, []);

  useEffect(() => {
    if(plantoesHistorico.length > 0){
      getHistoricoAgendamentos()
    }
  }, [dataInicialHistorico, dataFinalHistorico, plantoesHistorico])

  useEffect(() => {
    getRankingAgendamentosConcretizados();
  }, [dataInicialRankingConcretizados, dataFinalRankingConcretizados, regiaoRankingConcretizados]);

  useEffect(() => {
    getRankingAgendamentosNaoConcretizados();
  }, [dataInicialRankingNaoConcretizados, dataFinalRankingNaoConcretizados, regiaoRankingNaoConcretizados]);

  useEffect(() => {
    if(plantoesProximosAgendamentos.length > 0){
      getProximosAgendamentos();
    }
  }, [plantoesProximosAgendamentos]);

  useEffect(() => {
    if(plantoesEvolucao.length > 0){
      getEvolucaoAgendamentos()
    }
  }, [periodo, plantoesEvolucao]);

  useEffect(() => {
    getPlantoesRegiaoEvolucao();
  }, [regiaoEvolucao]);

  useEffect(() => {
    getPlantoesRegiaoHistorico();
  }, [regiaoHistorico]);

  useEffect(() => {
    getPlantoesProximosAgendamentos();
  }, [regiaoProximosAgendamentos]);

  const getPlantoesProximosAgendamentos = () => {
    let ids = [];

    if(regiaoProximosAgendamentos?.id === null || regiaoProximosAgendamentos?.id === undefined){
      ids = shifts;
    } else {
      regionais.map(regional => {
        if(regional.id === regiaoProximosAgendamentos.id){
          regional.plantoes.map(plantao => {
            ids.push(plantao.id);
          })
        }
      });
    }

    setPlantoesProximosAgendamentos(ids);
  }

  const getPlantoesRegiaoHistorico = () => {
    let ids = [];

    if(regiaoHistorico?.id === null || regiaoHistorico?.id === undefined){
      ids = shifts;
    } else {
      regionais.map(regional => {
        if(regional.id === regiaoHistorico.id){
          regional.plantoes.map(plantao => {
            ids.push(plantao.id);
          })
        }
      });
    }

    setPlantoesHistorico(ids);
  }

  const getPlantoesRegiaoEvolucao = () => {
    let ids = [];

    if(regiaoEvolucao?.id === null || regiaoEvolucao?.id === undefined){
      ids = shifts;
    } else {
      regionais.map(regional => {
        if(regional.id === regiaoEvolucao.id){
          regional.plantoes.map(plantao => {
            ids.push(plantao.id);
          })
        }
      });
    }

    setPlantoesEvolucao(ids);
  }

  const getProximosAgendamentos = () => {
    setLoadingProximosAgendamentos(true);

    const filterRegional = (plantoesProximosAgendamentos.length === totalShiftsNumber)
      ? null
      : plantoesProximosAgendamentos.join(',');

    api.get('/agendamentos/proximos', {
      params: {
        regional_id: regiaoProximosAgendamentos?.id ?? null,
        plantoes_ids: filterRegional
      }
    })
      .then(res => {
        setProximosAgendamentos( orderProximosAgendamentos(res.data.data) );
      })
      .catch(err => {
        console.log(err);
      })
      .then(() => setLoadingProximosAgendamentos(false));
  }

  const orderProximosAgendamentos = datas => {
    datas.map((data, index) => {
      datas[index].plantoes = data.plantoes.sort(function (a, b) {   
        return b.confirmados - a.confirmados || b.aguardando_confirmacao - a.aguardando_confirmacao;
      });
    });

    return datas;
  }

  const getHistoricoAgendamentos = () => {
    setLoadingHistoricoAgendamentos(true);

    const filterRegional = (plantoesHistorico.length === totalShiftsNumber)
      ? null
      : plantoesHistorico.join(',');

    api.get('/agendamentos/total', {
      params: {
        date_start: moment(dataInicialHistorico).format('YYYY-MM-DD'),
        date_end: moment(dataFinalHistorico).format('YYYY-MM-DD'),
        plantoes_ids: filterRegional,
        regional_id: regiaoHistorico?.id ?? null
      }
    })
      .then(res => {
        setHistoricoAgendamentos(res.data.data);
      })
      .catch(err => {
        console.log(err);
      })
      .then(() => setLoadingHistoricoAgendamentos(false));
  }

  const getEvolucaoAgendamentos = () => {
    setLoadingEvolucaoAgendamentos(true);

    const filterRegional = (plantoesEvolucao.length === totalShiftsNumber)
      ? null
      : plantoesEvolucao.join(',');

    api.get('/agendamentos/evolucao', {
      params: {
        periodo,
        plantoes_ids: filterRegional,
        regional_id: regiaoEvolucao?.id ?? null
      }
    })
      .then(res => {
        setEvolucaoAgendamentos(res.data.data);
      })
      .catch(err => {
        console.log(err);
      })
      .then(() => setLoadingEvolucaoAgendamentos(false));
  }

  const getRankingAgendamentosConcretizados = () => {
    setLoadingRankingAgendamentosConcretizados(true);

    api.get('/agendamentos/ranking-concretizados', {
      params: {
        date_start: moment(dataInicialRankingConcretizados).format('YYYY-MM-DD'),
        date_end: moment(dataFinalRankingConcretizados).format('YYYY-MM-DD'),
        regional_id: regiaoRankingConcretizados?.id ?? null
      }
    })
      .then(res => {
        let data = {
          corretores: res.data?.corretores ?? [],
          gerentes: res.data?.gerentes ?? [],
          superintendentes: res.data?.superintendentes ?? []
        };
        setRankingAgendamentos(data);
      })
      .catch(err => {
        console.log(err);
      })
      .then(() => setLoadingRankingAgendamentosConcretizados(false));
  }

  const getRankingAgendamentosNaoConcretizados = () => {
    setLoadingRankingAgendamentosNaoConcretizados(true);

    api.get('/agendamentos/ranking-nao-concretizados', {
      params: {
        date_start: moment(dataInicialRankingNaoConcretizados).format('YYYY-MM-DD'),
        date_end: moment(dataFinalRankingNaoConcretizados).format('YYYY-MM-DD'),
        regional_id: regiaoRankingNaoConcretizados?.id ?? null
      }
    })
      .then(res => {
        let data = {
          corretores: res.data?.corretores ?? [],
          gerentes: res.data?.gerentes ?? [],
          superintendentes: res.data?.superintendentes ?? []
        };
        setRankingAgendamentosNaoConcretizados(data);
      })
      .catch(err => {
        console.log(err);
      })
      .then(() => setLoadingRankingAgendamentosNaoConcretizados(false));
  }

  const handleDateHistorico = (start, final) => {
    setDataInicialHistorico(start);
    setDataFinalHistorico(final);
  }

  const handleDateRankingConcretizados = (start, final) => {
    setDataInicialRankingConcretizados(start);
    setDataFinalRankingConcretizados(final);
  }

  const handleDateRankingNaoConcretizados = (start, final) => {
    setDataInicialRankingNaoConcretizados(start);
    setDataFinalRankingNaoConcretizados(final);
  }

  const getShifts = async (filter = {}) => {

    setLoadingShifts(true);
    const { data, status } = await api.get(`list-plantoes`, {
      params: filter
    });
    let totalShifts = 0;
    let s = [];
    data.regionais.map(regional => {
      totalShifts += regional.plantoes.length;
      regional.plantoes.map(plantao => {
        s.push(plantao.id);
      });
    });
    setRegionais(data.regionais);
    setTotalShiftsNumber(totalShifts);
    setShifts(s);
    setPlantoesProximosAgendamentos(s);
    setPlantoesHistorico(s);
    setPlantoesEvolucao(s);

    if (status === 200) {
      setLoadingShifts(false);
    }
    if (typeof filter.regional_id === 'undefined' || filter.regional_id === 'null') {
      setTotalShifts(totalShifts);
    }
  }
  
  const goToMore = (perfil, ranking) => {
    let params = {
      sort_by: ranking,
      sort_dir: 'desc'
    };

    if(ranking === 'concretizados'){
      params.start_date = moment(dataInicialRankingConcretizados).format('YYYY-MM-DD');
      params.final_date = moment(dataFinalRankingConcretizados).format('YYYY-MM-DD');

      if(Object.keys(regiaoRankingConcretizados).length > 0){
        params.region_id = regiaoRankingConcretizados.id;
        params.region_nome = regiaoRankingConcretizados.nome;
        params.region_slug = regiaoRankingConcretizados.slug;
      }
    }
    if(ranking === 'nao_concretizados'){
      params.start_date = moment(dataInicialRankingNaoConcretizados).format('YYYY-MM-DD');
      params.final_date = moment(dataFinalRankingNaoConcretizados).format('YYYY-MM-DD');

      if(Object.keys(regiaoRankingNaoConcretizados).length > 0){
        params.region_id = regiaoRankingNaoConcretizados.id;
        params.region_nome = regiaoRankingNaoConcretizados.nome;
        params.region_slug = regiaoRankingNaoConcretizados.slug;
      }
    }

    let urlParams = createUrlParamsFromObject(params);

    return `agendamentos/${perfil}?${urlParams}`;
  }

  const getPeriodoFromStringSize = date => {
    let res = '';
    let length = date ? date.length : 0;
    
    switch (length) {
      case 10:
        res = 'diario';
        break;
      case 21:
        res = 'semanal';
        break;
      case 7:
        res = 'mensal';
        break;
    }

    return res;
  }

  const renderCustomAxisTick = ({ x, y, payload }) => {
    let date = payload.value;
    let firstLine = '';
    let secondLine = '';

    switch (getPeriodoFromStringSize(date)) {
      case 'diario':
        firstLine = moment(date).format('ddd').toUpperCase();
        secondLine = moment(date).format('DD/MM');
        break;
      case 'semanal':
        let datas = date.includes(',') ? date.split(',') : [];
        firstLine = moment(datas[0]).format('DD/MM');
        secondLine = moment(datas[1]).format('DD/MM');
        break;
      case 'mensal':
        firstLine = moment(date).format('MMM').toUpperCase();
        secondLine = moment(date).format('YYYY');
        break;
    }
    
    return (
      <>
        <text x={x} y={y + 20} style={{ fontWeight: periodo === 'semanal' ? 'normal' : 'bold', fontSize: 14 }} textAnchor="middle">{firstLine}</text>
        <text x={x} y={y + 40} style={{ fontSize: 14 }} textAnchor="middle">{secondLine}</text>
      </>
    );
  }
  
  const CustomTooltip = ({ active, payload, label }) => {
    switch (getPeriodoFromStringSize(label)) {
      case 'diario':
        label = `${moment(label).format('dddd')}`;
        break;
      case 'semanal':
        let datas = label.split(',');
        label = `${moment(datas[0]).format('DD/MM/YYYY')} a ${moment(datas[1]).format('DD/MM/YYYY')}`;
        break;
      case 'mensal':
        label = moment(label).format('MMMM/YYYY').toUpperCase();
        break;
    }

    if (active && payload && payload.length) {
      return (
        <div className="custom-chart-tooltip">
          <p className="label">{label}</p>
          {payload.map(data => (
            <p className="value" style={{ color: data.color }}>{labels[data.name]} : {data.value.toLocaleString()}</p>
          ))}
        </div>
      );
    }

    return null;
  }

  const renderColorfulLegendText = (value, entry) => {
    const { color } = entry;
    return <span style={{ color, fontSize: 14 }}>{labels[value].toUpperCase()}</span>;
  };

  return (
    <>
      {showModalProximosAgendamentosRegiao &&
        <ModalRegion
          handleClose={() => setShowModalProximosAgendamentosRegiao(false)}
          handleRegion={setRegiaoProximosAgendamentos}
        />
      }
      {showModalPlantoesProximosAgendamentos &&
        <ModalShift
          handleClose={() => setShowModalPlantoesProximosAgendamentos(false)}
          handleShift={setPlantoesProximosAgendamentos}
          shifts={plantoesProximosAgendamentos}
          region={regiaoProximosAgendamentos}
        />
      }
      {showModalHistoricoRegiao &&
        <ModalRegion handleClose={() => setShowModalHistoricoRegiao(false)}
          handleRegion={setRegiaoHistorico} />
      }
      {showModalHistoricoPlantoes &&
        <ModalShift
          handleClose={() => setShowModalHistoricoPlantoes(false)}
          handleShift={setPlantoesHistorico}
          shifts={plantoesHistorico}
          region={regiaoHistorico}
        />
      }
      {showModalEvolucaoRegiao &&
        <ModalRegion handleClose={() => setShowModalEvolucaoRegiao(false)}
          handleRegion={setRegiaoEvolucao}
        />
      }
      {showModalEvolucaoPlantoes &&
        <ModalShift handleClose={() => setShowModalEvolucaoPlantoes(false)}
          handleShift={setPlantoesEvolucao}
          shifts={plantoesEvolucao}
          region={regiaoEvolucao}
        />
      }
      {showModalEvolucaoPeriodo &&
        <ModalPeriodo
          handleClose={() => setShowModalEvolucaoPeriodo(false)}
          setPeriodo={setPeriodo}
        />
      }
      {showModalRankingConcretizadosRegiao &&
        <ModalRegion handleClose={() => setShowModalRankingConcretizadosRegiao(false)}
          handleRegion={setRegiaoRankingConcretizados}
        />
      }
      {showModalRankingNaoConcretizadosRegiao &&
        <ModalRegion handleClose={() => setShowModalRankingNaoConcretizadosRegiao(false)}
          handleRegion={setRegiaoRankingNaoConcretizados}
        />
      }

      <section id="content">
        <Header icon={<img src={calendar4} />} title="Agendamentos" subtitle=""  />
        <>
        <div className="pd-37">
          <div className="box light-grey">
            <div className="box-header">
              <div className="box-title">
                <img src={dash} />
                <div className="box-title-text">
                  <h2>Próximos agendamentos</h2>
                </div>
              </div>
              <div className="box-tools">

                {userInfo?.isMaster &&
                  <button className="btn-filter" style={{ minWidth: 180 }} onClick={() => setShowModalProximosAgendamentosRegiao(true)}>
                    {loadingShifts &&
                      <Loading cWidth={120} cHeight={40} />
                    }
                    {!loadingShifts &&
                      <>
                        {<img src={icon[regiaoProximosAgendamentos?.slug] ?? br} />}
                        {<span>{regiaoProximosAgendamentos?.nome ?? 'Brasil'}</span>}
                      </>
                    }
                  </button>
                }

                <button className="btn-filter" style={{ minWidth: 250 }} onClick={() => setShowModalPlantoesProximosAgendamentos(true)}>
                  {loadingShifts &&
                    <Loading cWidth={120} cHeight={40} />
                  }
                  {!loadingShifts &&
                    <>
                      <img src={pin2} />
                      <span> {plantoesProximosAgendamentos.length === totalShifts ? `Todos os plantões` : `${plantoesProximosAgendamentos.length}  ${plantoesProximosAgendamentos.length === 1 ? 'Plantão selecionado' : 'Plantões selecionados'}`}</span>
                    </>
                  }

                </button>
              </div>
            </div>
            <div className="box-body">
              <Row>
                {proximosAgendamentos !== null &&
                  <>
                    {proximosAgendamentos.map((agendamento, index) => (
                      <Col key={index} sm={4}>
                        <div className="box-card">
                          <div className="box-card-header center dark-blue">
                            <h3>{moment(agendamento.data).format('DD/MM/YYYY')}</h3>
                          </div>
                          <div className="box-card-body box-card-no-padding card-agendamentos">
                            <div className="d-flex-count">
                              <div className="group-count">
                                {loadingProximosAgendamentos &&
                                  <Loading cWidth={100} cHeight={48} />
                                }
                                {!loadingProximosAgendamentos &&
                                  <span className="n-count">{agendamento.confirmados}</span>
                                }
                                <span className="desc-count">Confirmados</span>
                              </div>
                              <div className="divider"></div>
                              <div className="group-count">
                                {loadingProximosAgendamentos &&
                                  <Loading cWidth={100} cHeight={48} />
                                }
                                {!loadingProximosAgendamentos &&
                                  <span className="n-count f-40 color-light-blue">{agendamento.aguardando_confirmacao}</span>
                                }
                                <span className="desc-count">Aguardando<br />Confirmação</span>
                              </div>
                            </div>
                            <div className="pd-table">
                              <table className="table-dash table-head">
                                <thead>
                                  <tr>
                                    <th width={230}><span>Produto</span></th>
                                    <th><img src={check3} alt="Icon" /></th>
                                    <th width={100}><img src={waiting} alt="Icon" /></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {agendamento.plantoes.map((plantao, index) => (
                                    <tr key={index}>
                                      <td><span className="pl-20">{plantao.imovel_nome}</span></td>
                                      <td><span className="color-medium-blue f-bold">{plantao.confirmados}</span></td>
                                      <td><span className="color-light-blue">{plantao.aguardando_confirmacao}</span></td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </Col>
                    ))}
                  </>
                }
              </Row>
            </div>
          </div>

          <div className="box light-grey">
            <div className="box-header">
              <div className="box-title">
                <div className="box-title-text">
                  <h2>Histórico</h2>
                </div>
              </div>
              <div className="box-tools">
                {userInfo?.isMaster &&
                  <button className="btn-filter" style={{ minWidth: 180 }} onClick={() => setShowModalHistoricoRegiao(true)}>
                    {loadingShifts &&
                      <Loading cWidth={120} cHeight={40} />
                    }
                    {!loadingShifts &&
                      <>
                        <img src={icon[regiaoHistorico?.slug] ?? br} />
                        {<span>{regiaoHistorico?.nome ?? 'Brasil'}</span>}
                      </>
                    }
                  </button>
                }

                <button className="btn-filter" style={{ minWidth: 250 }} onClick={() => setShowModalHistoricoPlantoes(true)}>
                  {loadingHistoricoAgendamentos &&
                    <Loading cWidth={120} cHeight={40} />
                  }
                  {!loadingHistoricoAgendamentos &&
                    <>
                      <img src={pin2} />
                      <span> {plantoesHistorico.length === totalShifts ? `Todos os plantões` : `${plantoesHistorico.length}  ${plantoesHistorico.length === 1 ? 'Plantão selecionado' : 'Plantões selecionados'}`}</span>
                    </>
                  }
                </button>
                <InputDate maxIsToday={true} cStartDate={dataInicialHistorico} cFinalDate={dataFinalHistorico} handleDate={handleDateHistorico} />
              </div>
            </div>
            <div className="box-body">
              <Row>
                <Col sm={4}>
                  <div className="box-card box-card-shifts box-card-height">
                    <div className="box-card-body">
                      <div className="group-count">
                        <div className="group-count-shifts colorLightBlue">
                          <span className="n-count">{historicoAgendamentos?.total_agendamentos}</span>
                        </div>
                        <span className="desc-count">Agendamentos <br />totais</span>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col sm={4}>
                  <div className="box-card box-card-shifts box-card-height">
                    <div className="box-card-body">
                      <div className="group-count">
                        <div className="group-count-shifts" id="colorGreen">
                          <span className="n-count">{historicoAgendamentos?.concretizados}</span>
                        </div>
                        <span className="desc-count">Concretizados</span>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col sm={4}>
                  <div className="box-card box-card-shifts box-card-height">
                    <div className="box-card-body">
                      <div className="group-count">
                        <div className="group-count-shifts" id="colorOrange">
                          <span className="n-count">{historicoAgendamentos?.nao_concretizados}</span>
                        </div>
                        <span className="desc-count">Não concretizados</span>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>

          <div className="box box-border">
            <Row>
              <Col sm={4}>
                <div className="box-card-body">
                  <h3>Evolução de agendamentos</h3>
                  {userInfo?.isMaster &&
                    <button className="btn-filter mb-20 btn-box-shadow" style={{ minWidth: 250 }} onClick={() => setShowModalEvolucaoRegiao(true)}>
                      {loadingShifts &&
                        <Loading cWidth={120} cHeight={40} />
                      }
                      {!loadingShifts &&
                        <>
                          {<img src={icon[regiaoEvolucao?.slug] ?? br} />}
                          {<span>{regiaoEvolucao?.nome ?? 'Brasil'}</span>}
                        </>
                      }
                    </button>
                  }
                  <button className="btn-filter mb-20 btn-box-shadow" style={{ minWidth: 250 }} onClick={() => setShowModalEvolucaoPlantoes(true)}>
                    {loadingShifts &&
                      <Loading cWidth={120} cHeight={40} />
                    }
                    {!loadingShifts &&
                      <>
                        <img src={pin2} />
                        <span> {plantoesEvolucao.length === totalShifts ? `Todos os plantões` : `${plantoesEvolucao.length} ${plantoesEvolucao.length === 1 ? 'Plantão selecionado' : 'Plantões selecionados'}`}</span>
                      </>
                    }
                  </button>
                  <button className="btn-filter mb-20 btn-box-shadow" style={{ minWidth: 250 }} onClick={() => setShowModalEvolucaoPeriodo(true)}>
                    {loadingEvolucaoAgendamentos &&
                      <Loading cWidth={120} cHeight={40} />
                    }
                    {!loadingEvolucaoAgendamentos &&
                      <>
                        {periodo == 'diario' &&
                          <img src={calendar6} />
                        }
                        {periodo == 'semanal' &&
                          <img src={calendar7} />
                        }
                        {periodo == 'mensal' &&
                          <img src={calendar8} />
                        }
                        <span> {periodo == 'diario' ? 'Diário' : periodo} </span>
                      </>
                    }
                  </button>
                </div>
              </Col>
              <Col sm={8}>
                  {loadingEvolucaoAgendamentos &&
                    <Loading cWidth={`100%`} cHeight={400} />
                  }
                  {!loadingEvolucaoAgendamentos &&
                    <ResponsiveContainer width="100%" height={400}>
                      <BarChart
                        width={580}
                        height={300}
                        data={evolucaoAgendamentos}
                      >
                        <CartesianGrid strokeDasharray="1 1" />
                        <XAxis 
                          dataKey="periodo"
                          interval={0}
                          tick={renderCustomAxisTick} 
                        />
                        <YAxis 
                          tickFormatter={tick => {
                            return tick.toLocaleString();
                          }}
                        />
                        <RechartsTooltip content={<CustomTooltip />} cursor={{ fill: '#ECECEC'}} />
                        <Bar dataKey="concretizados" stackId="a" barSize={50} fill="#02C39A"/>
                        <Bar dataKey="nao_concretizados" stackId="a" barSize={50} fill="#FF6542"/>
                        <Legend wrapperStyle={{ bottom: -30 }} height={50} formatter={renderColorfulLegendText}/>
                      </BarChart>
                    </ResponsiveContainer>
                  }
              </Col>
            </Row>
          </div>

          <div className="box dark-blue">
            <div className="box-header">
              <div className="box-title">
                <img src={calendar5} />
                <h2>Ranking de atendimentos <br /> por agendamento</h2>
              </div>
              <div className="box-tools">

                {userInfo?.isMaster &&
                  <button className="btn-filter" style={{ minWidth: 180 }} onClick={() => setShowModalRankingConcretizadosRegiao(true)}>
                    {loadingShifts &&
                      <Loading cWidth={120} cHeight={40} />
                    }
                    {!loadingShifts &&
                      <>
                        {<img src={icon[regiaoRankingConcretizados?.slug] ?? br} />}
                        {<span>{regiaoRankingConcretizados?.nome ?? 'Brasil'}</span>}
                      </>
                    }
                  </button>
                }

                <InputDate maxIsToday={true} cStartDate={dataInicialRankingConcretizados} cFinalDate={dataFinalRankingConcretizados}
                  handleDate={handleDateRankingConcretizados} />
              </div>
            </div>
            <div className="box-body">
              <Row>
                <Col sm={4}>
                  <div className="box-card h-full">
                    <div className="box-card-header light-blue">
                      <h3>Top 5 corretores</h3>
                    </div>
                    <div className="box-card-body">
                      {loadingRankingAgendamentosConcretizados &&
                        <TableLoading loop={10} multiply={25} cHeight={12} viewBoxHeight={300} />
                      }
                      {!loadingRankingAgendamentosConcretizados &&
                        <>
                          <table className="table-dash">
                            <thead>
                              <tr>
                                <th>Corretor</th>
                                <th>Gerente</th>
                                <th>Total</th>
                              </tr>
                            </thead>
                            <tbody>
                              {rankingAgendamentos?.corretores.map((corretor, key) => (
                                <tr key={key}>
                                  <td>{corretor.apelido}</td>
                                  <td>{corretor?.gerente?.apelido ?? '-'}</td>
                                  <td>{corretor.total.concretizados}</td>
                                </tr>
                              ))}
                              {rankingAgendamentos?.corretores.length === 0 && 
                                <td>
                                  <td colSpan={3}>Nenhum atendimento</td>
                                </td>
                              }
                            </tbody>
                          </table>
                          {rankingAgendamentos?.corretores.length > 0 &&
                            <a href={`${goToMore('corretores', 'concretizados')}`}>
                              <img src={plusCircle} />
                              Ver mais
                            </a>
                          }
                        </>
                      }

                    </div>
                  </div>
                </Col>

                {(userInfo?.isUserEspecial || userInfo?.isSuperintendente || userInfo?.isDiretor) &&
                  <Col sm={4}>
                    <div className="box-card h-full">
                      <div className="box-card-header light-blue">
                        <h3>Top 5 gerentes</h3>
                      </div>
                      <div className="box-card-body">
                        {loadingRankingAgendamentosConcretizados &&
                          <TableLoading loop={10} multiply={25} cHeight={12} viewBoxHeight={300} />
                        }
                        {!loadingRankingAgendamentosConcretizados &&
                          <>
                            <table className="table-dash">
                              <thead>
                                <tr>
                                  <th>Gerente</th>
                                  <th>Sup</th>
                                  <th>Total</th>
                                </tr>
                              </thead>
                              <tbody>
                                {rankingAgendamentos?.gerentes.map((gerente, key) => (
                                  <tr key={key}>
                                    <td>{gerente.apelido}</td>
                                    <td>{gerente?.superintendente?.apelido ?? '-'}</td>
                                    <td>{gerente.total.concretizados}</td>
                                  </tr>
                                ))}
                                {rankingAgendamentos.gerentes.length === 0 && 
                                  <td>
                                    <td colSpan={3}>Nenhum atendimento</td>
                                  </td>
                                }
                              </tbody>
                            </table>
                            {rankingAgendamentos.gerentes.length > 0 &&
                              <a href={`${goToMore('gerentes', 'concretizados')}`}>
                                <img src={plusCircle} />
                                Ver mais
                              </a>
                            }
                          </>
                        }

                      </div>
                    </div>
                  </Col>
                }

                {(userInfo?.isUserEspecial || userInfo?.isDiretor) &&
                  <Col sm={4}>
                    <div className="box-card h-full">
                      <div className="box-card-header light-blue">
                        <h3>Top 5 superintendentes</h3>
                      </div>
                      <div className="box-card-body">
                        {loadingRankingAgendamentosConcretizados &&
                          <TableLoading loop={10} multiply={25} cHeight={12} viewBoxHeight={300} />
                        }
                        {!loadingRankingAgendamentosConcretizados &&
                          <>
                            <table className="table-dash">
                              <thead>
                                <tr>
                                  <th>Sup</th>
                                  <th>Diretor</th>
                                  <th>Total</th>
                                </tr>
                              </thead>
                              <tbody>
                                {rankingAgendamentos?.superintendentes.map((superintendente, key) => (
                                  <tr key={key}>
                                    <td>{superintendente.apelido}</td>
                                    <td>{superintendente?.diretor?.apelido ?? '-'}</td>
                                    <td>{superintendente.total.concretizados}</td>
                                  </tr>
                                ))}
                                {rankingAgendamentos.superintendentes.length === 0 && 
                                  <td>
                                    <td colSpan={3}>Nenhum atendimento</td>
                                  </td>
                                }
                              </tbody>
                            </table>
                            {rankingAgendamentos.superintendentes.length > 0 &&
                              <a href={`${goToMore('superintendentes', 'concretizados')}`}>
                                <img src={plusCircle} />
                                Ver mais
                              </a>
                            }
                          </>
                        }

                      </div>
                    </div>
                  </Col>
                }
              </Row>
            </div>
          </div>

          <div className="box dark-gray">
            <div className="box-header">
              <div className="box-title">
                <img src={closeCircle} />
                <h2>Ranking de agendamentos <br /> não concretizados</h2>
              </div>
              <div className="box-tools">

                {userInfo?.isMaster &&
                  <button className="btn-filter" style={{ minWidth: 180 }} onClick={() => setShowModalRankingNaoConcretizadosRegiao(true)}>
                    {loadingShifts &&
                      <Loading cWidth={120} cHeight={40} />
                    }
                    {!loadingShifts &&
                      <>
                        {<img src={icon[regiaoRankingNaoConcretizados?.slug] ?? br} />}
                        {<span>{regiaoRankingNaoConcretizados?.nome ?? 'Brasil'}</span>}
                      </>
                    }
                  </button>
                }

                <InputDate maxIsToday={true} cStartDate={dataInicialRankingNaoConcretizados} cFinalDate={dataFinalRankingNaoConcretizados}
                  handleDate={handleDateRankingNaoConcretizados} />
              </div>
            </div>
            <div className="box-body">
              <Row>
                <Col sm={4}>
                  <div className="box-card h-full">
                    <div className="box-card-header light-blue">
                      <h3>Top 5 corretores</h3>
                    </div>
                    <div className="box-card-body">
                      {loadingRankingAgendamentosNaoConcretizados &&
                        <TableLoading loop={10} multiply={25} cHeight={12} viewBoxHeight={300} />
                      }
                      {!loadingRankingAgendamentosNaoConcretizados &&
                        <>
                          <table className="table-dash">
                            <thead>
                              <tr>
                                <th>Corretor</th>
                                <th>Gerente</th>
                                <th>Total</th>
                              </tr>
                            </thead>
                            <tbody>
                              {rankingAgendamentosNaoConcretizados?.corretores.map((corretor, key) => (
                                <tr key={key}>
                                  <td>{corretor.apelido}</td>
                                  <td>{corretor?.gerente?.apelido ?? '-'}</td>
                                  <td className='red'>{corretor.total.nao_concretizados}</td>
                                </tr>
                              ))}
                              {rankingAgendamentosNaoConcretizados.corretores.length === 0 && 
                                <td>
                                  <td colSpan={3}>Nenhum agendamento</td>
                                </td>
                              }
                            </tbody>
                          </table>
                          {rankingAgendamentosNaoConcretizados.corretores.length > 0 &&
                            <a href={`${goToMore('corretores', 'nao_concretizados')}`}>
                              <img src={plusCircle} />
                              Ver mais
                            </a>
                          }
                        </>
                      }

                    </div>
                  </div>
                </Col>

                {(userInfo?.isUserEspecial || userInfo?.isSuperintendente || userInfo?.isDiretor) &&
                  <Col sm={4}>
                    <div className="box-card h-full">
                      <div className="box-card-header light-blue">
                        <h3>Top 5 gerentes</h3>
                      </div>
                      <div className="box-card-body">
                        {loadingRankingAgendamentosNaoConcretizados &&
                          <TableLoading loop={10} multiply={25} cHeight={12} viewBoxHeight={300} />
                        }
                        {!loadingRankingAgendamentosNaoConcretizados &&
                          <>
                            <table className="table-dash">
                              <thead>
                                <tr>
                                  <th>Gerente</th>
                                  <th>Sup</th>
                                  <th>Total</th>
                                </tr>
                              </thead>
                              <tbody>
                                {rankingAgendamentosNaoConcretizados?.gerentes.map((gerente, key) => (
                                  <tr key={key}>
                                    <td>{gerente.apelido}</td>
                                    <td>{gerente?.superintendente?.apelido ?? '-'}</td>
                                    <td className='red'>{gerente.total.nao_concretizados}</td>
                                  </tr>
                                ))}
                                {rankingAgendamentosNaoConcretizados.gerentes.length === 0 && 
                                  <td>
                                    <td colSpan={3}>Nenhum agendamento</td>
                                  </td>
                                }
                              </tbody>
                            </table>
                            {rankingAgendamentosNaoConcretizados.gerentes.length > 0 &&
                              <a href={`${goToMore('gerentes', 'nao_concretizados')}`}>
                                <img src={plusCircle} />
                                Ver mais
                              </a>
                            }
                          </>
                        }

                      </div>
                    </div>
                  </Col>
                }

                {(userInfo?.isUserEspecial || userInfo?.isDiretor) &&
                  <Col sm={4}>
                    <div className="box-card h-full">
                      <div className="box-card-header light-blue">
                        <h3>Top 5 superintendentes</h3>
                      </div>
                      <div className="box-card-body">
                        {loadingRankingAgendamentosNaoConcretizados &&
                          <TableLoading loop={10} multiply={25} cHeight={12} viewBoxHeight={300} />
                        }
                        {!loadingRankingAgendamentosNaoConcretizados &&
                          <>
                            <table className="table-dash">
                              <thead>
                                <tr>
                                  <th>Sup</th>
                                  <th>Diretor</th>
                                  <th>Total</th>
                                </tr>
                              </thead>
                              <tbody>
                                {rankingAgendamentosNaoConcretizados?.superintendentes.map((superintendente, key) => (
                                  <tr key={key}>
                                    <td>{superintendente.apelido}</td>
                                    <td>{superintendente?.diretor?.apelido ?? '-'}</td>
                                    <td className='red'>{superintendente.total.nao_concretizados}</td>
                                  </tr>
                                ))}
                                {rankingAgendamentosNaoConcretizados.superintendentes.length === 0 && 
                                  <td>
                                    <td colSpan={3}>Nenhum agendamento</td>
                                  </td>
                                }
                              </tbody>
                            </table>
                            {rankingAgendamentosNaoConcretizados.superintendentes.length > 0 &&
                              <a href={`${goToMore('superintendentes', 'nao_concretizados')}`}>
                                <img src={plusCircle} />
                                Ver mais
                              </a>
                            }
                          </>
                        }

                      </div>
                    </div>
                  </Col>
                }
              </Row>
            </div>
          </div>
        </div>
        </>
      </section>
    </>
  );

}

export default Agendamentos;